import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { useGarageStore } from '@/modules/FindGarage'
import { UpdatedLog } from '@/types/logs'
import { useAreaStore, useGetAreas } from '@/modules/Areas'
import { useMemo } from 'react'

const GET_UNFINISHED_LOGS_KEY = 'unfinishedLogs'

export const useGetPMUnfinishedLogs = () => {
    const { garage } = useGarageStore()
    const { data: areas = [] } = useGetAreas()
    const { selectedAreaCode } = useAreaStore()

    const routesToLoad = useMemo(() => {
        const selectedArea = areas?.find((item) => item.code === selectedAreaCode)
        const source = selectedArea ? selectedArea.workstations : areas.flatMap((item) => item.workstations)

        return source.flatMap((item) => item.routes.flatMap((route) => route.route))
    }, [areas, selectedAreaCode])

    return useAppQuery<UpdatedLog[]>({
        queryKey: [GET_UNFINISHED_LOGS_KEY, routesToLoad, garage?.shortCode],
        queryFn: ({ queryKey, signal }) =>
            createInstance({
                url: '/controller-logs/unfinished',
                method: 'GET',
                params: {
                    Routes: queryKey[1] as string[],
                    GarageSc: queryKey[2] as string,
                },
                paramsSerializer: {
                    indexes: null,
                },
                signal,
            }),
        select: (data) => {
            return [...data].reverse()
        },
        enabled: routesToLoad?.length > 0,
        refetchInterval: 1000 * 60,
        refetchIntervalInBackground: true,
        networkMode: 'offlineFirst',
    })
}
